<div class="view-invoice">
  <div class="view-invoice-left-bar"></div>

  <div class="view-invoice-right">
    <div class="view-invoice-right-title" *ngIf="isShowInvoiceOrdinal">
      {{ "ENTRY_SUMMARY.INVOICE" | translate }}
      <b>#{{ invoiceOrdinal }}</b>
    </div>

    <div class="view-invoice-right-header" *ngIf="!isHasEsOcrRedesign">
      <div class="view-invoice-right-header-error" *ngIf="isShowError">
        <div class="view-invoice-right-header-error-left">
          <div class="view-invoice-right-header-error-icon">
            <img alt="attention" src="assets/icons/icon_warning_md_red.svg" class="view-invoice-right-header-error-icon-img" />
          </div>
          <div class="view-invoice-right-header-error-text">
            {{ errorText | translate }}
          </div>
        </div>

        <div class="view-invoice-right-header-error-right">
          <button type="button" class="view-invoice-btn-review-btn" *ngIf="isShowReviewHeader" (click)="reviewInvoice.emit()">
            <span class="view-invoice-btn-review-btn-inner">
              <span class="view-invoice-btn-review-btn-wrench"><img src="/assets/icons/icon_wrench.svg" /></span>
              <span>{{ "REVIEW_N_FIX" | translate }}</span>
            </span>
          </button>

          <button type="button" class="view-invoice-btn-clear-btn" *ngIf="isShowClearHeader" (click)="onShowClearInvoiceConfirm()">
            <span class="view-invoice-btn-clear-btn-inner">
              <span class="view-invoice-btn-clear-btn-trash"><img src="/assets/icons/icon_trash.svg" /></span>
              <span>{{ "BUTTON.CLEAR_ALL" | translate }}</span>
            </span>
          </button>
        </div>
      </div>
    </div>

    <div class="view-invoice-right-info">
      <div *ngIf="!isHasEsOcrRedesign" class="view-invoice-right-info-preview">
        <es-invoice-replace-ocr
          *ngIf="!previewImgUrl && isEditable && !isLoadingThumb"
          [billOfLadingId]="billOfLadingId"
          [existingInvoice]="invoice"
          [rootEntityId]="esId"
          [isBatchES]="isBatchES"
          [rootEntityType]="enumDocumentRootEntityType.ENTRY_SUMMARY"
          (rerunOCR)="replaceInvoice.emit($event)"
          (fileUploaded)="fileUploaded.emit()"
        ></es-invoice-replace-ocr>

        <div
          class="view-invoice-right-info-preview-image"
          *ngIf="(!isHasEsOcrRedesign || isSupportOrAdmin) && !!previewImgUrl && isImagePreview(previewImgUrl)"
          [style.background-image]="previewImgUrlForBg"
        >
          <div
            class="view-invoice-right-info-preview-icon view-invoice-right-info-preview-icon-eye"
            [ngClass]="{ disabled: !isImagePreview(previewImgUrl) }"
            nz-popover
            nzPopoverOverlayClassName="tooltip-sm"
            nzPopoverTrigger="hover"
            [nzPopoverContent]="'SHOW_INVOICE' | translate"
            (click)="showInvoice()"
          >
            <img
              class="view-invoice-right-info-preview-icon-img view-invoice-right-info-preview-icon-img-eye"
              src="/assets/icons/icon_eye.svg"
            />
          </div>

          <div
            *ngIf="!isFormOpened"
            class="view-invoice-right-info-preview-icon view-invoice-right-info-preview-icon-download"
            nz-popover
            nzPopoverOverlayClassName="tooltip-sm"
            nzPopoverTrigger="hover"
            [nzPopoverContent]="'DOWNLOAD_INVOICE' | translate"
            (click)="downloadInvoice()"
          >
            <img
              class="view-invoice-right-info-preview-icon-img view-invoice-right-info-preview-icon-img-download"
              src="/assets/icons/icon_download_gray_md.svg"
            />
          </div>

          <div class="view-invoice-right-info-preview-icon view-invoice-right-info-preview-icon-replace" *ngIf="isFormOpened">
            <es-invoice-replace-ocr
              [billOfLadingId]="billOfLadingId"
              [isSmallIcon]="true"
              [existingInvoice]="invoice"
              [rootEntityId]="esId"
              [isBatchES]="isBatchES"
              [rootEntityType]="enumDocumentRootEntityType.ENTRY_SUMMARY"
              (rerunOCR)="replaceInvoice.emit($event)"
              (fileUploaded)="fileUploaded.emit()"
              (loadingChanged)="setLoadingReplacedThumb($event)"
            ></es-invoice-replace-ocr>
          </div>

          <loading-spinner [show]="isLoadingReplacedThumb"></loading-spinner>
        </div>
      </div>

      <div class="view-invoice-right-info-main">
        <es-details-invoice-ocr-card-main-desktop
          *ngIf="!isFormOpened"
          [invoice]="invoice"
          [isEditable]="isEditable"
          [canEditInvoiceDetails]="canEditInvoiceDetails"
          [canDeleteInvoice]="canDeleteInvoice"
          [canEditLineItems]="canEditLineItems"
          [canClearInvoice]="canClearInvoice"
          [canEditManufacturer]="canEditManufacturer"
          [incoterms]="incotermsByType"
          [totalEnteredValueInUSD]="totalEnteredValueInUSD"
          [totalEnteredValue]="totalEnteredValue"
          [totalGrossWeight]="totalGrossWeight"
          [isShowCollapse]="isShowCollapse"
          [isOpenedItems]="isOpenedItems"
          (openItems)="openItems()"
          (closeItems)="closeItems()"
          (inputElementClick)="onReplaceInvoice()"
          (editInvoice)="editInvoice.emit()"
          (editMF)="editMF.emit()"
          (addLineItem)="addLineItem.emit()"
          (deleteInvoice)="deleteInvoice.emit()"
          (clearData)="showClearInvoice()"
        ></es-details-invoice-ocr-card-main-desktop>

        <es-details-invoice-ocr-card-form-desktop
          *ngIf="isFormOpened"
          [fg]="invoiceFg"
          [invoice]="invoice"
          [billOfLadingId]="billOfLadingId"
          [currencyRate]="currencyRate"
          [currencies]="currencies"
          [incoterms]="incoterms"
          (editMF)="editCleanMF.emit()"
          (saveInvoice)="saveInvoice()"
        ></es-details-invoice-ocr-card-form-desktop>
      </div>
    </div>

    <div>
      <es-details-invoice-ocr-card-hts-desktop
        *ngIf="isOpenedItems && !isFormOpened"
        [invoice]="invoice"
        [shipmentExportDate]="shipmentExportDate"
        [isEditable]="isEditable"
        [canEditLineItems]="canEditLineItems"
        [isInvoiceLinesCorrect]="isInvoiceLinesCorrect"
        [currencyRate]="currencyRate"
        [isCanBulkDelete]="isCanBulkDelete"
        (addLineItem)="addLineItem.emit()"
        (deleteLineItem)="deleteLineItem.emit($event)"
        (editLineItem)="editLineItem.emit($event)"
        (linesDeleted)="linesDeleted.emit()"
      ></es-details-invoice-ocr-card-hts-desktop>
    </div>

    <div><ng-container *ngTemplateOutlet="htsFooter"></ng-container></div>
  </div>
</div>

<ng-template #htsFooter>
  <div class="view-invoice-footer" *ngIf="invoice?.lines?.length && isOpenedItems && !isFormOpened">
    <div
      class="view-invoice-footer-button-wrapper"
      [ngClass]="{
        'justify-content-between': !isHasEsOcrRedesign,
        'justify-content-start': isHasEsOcrRedesign
      }"
      *ngIf="canEditLineItems ?? isEditable"
    >
      <div class="d-flex align-items-center">
        <button
          type="button"
          class="btn view-invoice-footer-button mr-1"
          [class.btn-primary]="!isAddLineItemOutline"
          [class.view-invoice-footer-button-outline]="isAddLineItemOutline"
          (click)="addLineItem.emit()"
        >
          <i class="fa fa-plus mr-2"></i>
          {{ "ADD_ANOTHER_LINE_ITEM" | translate }}
        </button>
        <button
          type="button"
          class="btn btn-primary view-invoice-footer-button ml-1"
          *ngIf="isShowFinalizeButton"
          [disabled]="isFinalizeDisabled"
          (click)="finalize.emit()"
        >
          {{ "HTS_ASSISTANT.FINALIZE" | translate }}
        </button>
      </div>

      <button
        type="button"
        class="btn view-invoice-footer-button view-invoice-footer-button-outline ml-1"
        *ngIf="isShowSave && !isHasEsOcrRedesign && isEditable"
        (click)="saveInvoiceHTS()"
      >
        {{ "BUTTON.SAVE_INVOICE" | translate }}
      </button>
    </div>
  </div>
</ng-template>

<a #link class="d-none" download></a>

<input
  #inputElement
  class="d-none"
  type="file"
  [id]="'replace-invoice-file-' + invoice.id"
  [accept]="allowedFileMimes.join(',')"
  (click)="clickInput()"
  (change)="handleFiles($event)"
/>

<custom-modal size="lg" [open]="isPreviewModalOpened" (openChange)="closePreviewModal()">
  <div class="position-relative" *ngIf="!!previewImgUrl && isPreviewModalOpened">
    <img [src]="previewImgUrl" appImgMagnifier [zoom]="3" class="w-100" />
  </div>
</custom-modal>

<custom-modal [header]="'CLEAR_SCANNED_DETAILS'" [open]="isShowClearInvoiceConfirm" (openChange)="onHideClearInvoiceConfirm()">
  <div>{{ "CLEAR_SCANNED_DETAILS_HINT" | translate }}</div>

  <div class="d-flex justify-content-between mt-4 mt-2">
    <button type="button" class="view-invoice-btn-clear-btn ml-0" (click)="clearData()">
      <span class="view-invoice-btn-clear-btn-inner">
        <span class="view-invoice-btn-clear-btn-trash"><img src="/assets/icons/icon_trash.svg" /></span>
        <span>{{ "CLEAR_DETAILS" | translate }}</span>
      </span>
    </button>

    <button type="button" class="view-invoice-btn-review-btn" (click)="onHideClearInvoiceConfirm(); reviewInvoice.emit()">
      <span class="view-invoice-btn-review-btn-inner">
        <span class="view-invoice-btn-review-btn-wrench"><img src="/assets/icons/icon_wrench.svg" /></span>
        <span>{{ "REVIEW_N_FIX" | translate }}</span>
      </span>
    </button>
  </div>
</custom-modal>
